import { motion } from "framer-motion";
import {
    Droplet,
    Flower2,
    Activity,
    MoveHorizontal,
    Sparkles,
    Leaf,
    Footprints,
} from "lucide-react";
import { SERVICES } from "@/lib/site-data";

const ICONS = { Droplet, Flower2, Activity, MoveHorizontal, Sparkles, Leaf, Footprints };

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 lg:py-36 bg-beige/60"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10">
                <div className="max-w-2xl mb-16 lg:mb-20">
                    <span className="eyebrow flex items-center gap-3">
                        <span className="w-8 h-px bg-gold" />
                        Our Therapies
                    </span>
                    <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
                        Treatments rooted in <em className="font-light text-gold-dark">tradition</em>.
                    </h2>
                    <p className="mt-5 text-base lg:text-lg text-ink-soft font-light leading-relaxed">
                        Seven signature therapies — each tuned to a different kind of tension. Choose
                        the one your body is asking for.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                    {SERVICES.map((s, i) => {
                        const Icon = ICONS[s.icon] || Leaf;
                        return (
                            <motion.div
                                key={s.id}
                                initial={{ opacity: 0, y: 25 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.6, delay: i * 0.07 }}
                                className="lux-card p-7 lg:p-8 group"
                                data-testid={`service-card-${s.id}`}
                            >
                                <div className="flex items-start justify-between mb-5">
                                    <div className="w-14 h-14 flex items-center justify-center bg-maroon text-gold rounded-full border border-gold/40 group-hover:bg-gold group-hover:text-maroon transition-all duration-500">
                                        <Icon size={22} strokeWidth={1.4} />
                                    </div>
                                    <span className="text-[0.65rem] tracking-[0.22em] uppercase text-gold-dark mt-2">
                                        from R{Math.min(...s.prices)}
                                    </span>
                                </div>
                                <h3 className="font-serif text-2xl lg:text-3xl text-maroon tracking-tight leading-tight">
                                    {s.name}
                                </h3>
                                <p className="mt-3 text-sm lg:text-base text-ink-soft font-light leading-relaxed">
                                    {s.blurb}
                                </p>
                                <div className="mt-6 pt-5 border-t border-gold/20 flex items-center justify-between text-xs tracking-widest uppercase text-ink-muted">
                                    <span>30 / 45 / 60 / 90 min</span>
                                    <span className="text-gold-dark group-hover:text-maroon transition-colors">→</span>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
